import { HTTP } from './http-common'
import { isEmpty } from 'lodash'

let subdomainUrl = 'rest'
const SUBDOMAIN_LIST = {
  [`${window.location.href.includes('localhost') || window.location.href.includes('develop')}`]: 'develop',
  [`${window.location.href.includes('staging')}`]: 'staging',
}

if (
  !!window &&
  !isEmpty(window)
) {

  subdomainUrl = SUBDOMAIN_LIST['true'] || 'rest'
}


export default {
  getAllLocations() {
    return new Promise((resolve, reject) => {
      HTTP.get('https://rest.cyrela.com.br/apicyrela/api/localizacao/estados-cidades-bairro-regioes-status?idImovelOrigem=3').then(response => {
        if (response.data.success) {
          resolve(response.data.filtroHomeTipos)
        }
      }).catch(error => {
        reject(error)
      })
    })
  },

  getNeighborhoodPage(url = '') {
    return new Promise((resolve, reject) => {
      HTTP.get(`https://${subdomainUrl}.cyrela.com.br/apicyrela/api/PaginaBairro/busca-por-url?idImovelOrigem=3&url=${url}`).then(response => {
        if (response.data.success) {
          resolve(response.data.paginaBairro)
        }
      }).catch(error => {
        reject(error)
      })
    })
  },
}



// WEBPACK FOOTER //
// ./src/api/locations.js